import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdActionContainerModel} from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/wf/md/actions

@Injectable({ providedIn: "root" })
export class WfMdActionService extends BaseApiTemplateService<WfMdActionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/actions";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/actions";
    this.httpClient = http;
  }
}
